// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4ffaca86","455":"e27f4cb3","977":"30e4c3fc"}[chunkId] + ".chunk.js";
};